import { useState } from "react";

import SectionContainer from "../container/SectionContainer";
import {
	Color,
	ColorV2,
	InputLocation,
} from "@adoptaunabuelo/react-components";
import { Search } from "lucide-react";
import { User, UserScheme } from "client-v2";
import { State } from "../../redux";
import { useSelector } from "react-redux";
import { useGoogleMaps } from "../../layout/GoogleMapsContext";

const LocationStep = (props: LocationProps) => {
	const { isLoaded } = useGoogleMaps();
	const translation = useSelector(
		(state: State) => state.location.translation,
	);
	const colors = {
		buttonBackground: ColorV2.surface.primary,
		buttonColor: "white",
		animation: ["#00315C", "#005AA8"],
	};

	const [inputError, setInputError] = useState(false);
	const [loading, setLoading] = useState(false);
	const [location, setLocation] = useState<LocationObjProps | undefined>(
		undefined,
	);

	const onNextClick = () => {
		if (location) {
			setLoading(true);
			User.set(props.user.objectId, {
				address: location.address,
				route: location.route,
				routeNumber: location.routeNumber,
				location: location.location,
				timeZone: location.timeZone,
				country: location.country,
				city: location.city,
				province: location.province,
				zipCode: location.zipCode,
				shortAddress: location.sortAddress,
			})
				.then((result) => {
					setLoading(false);
					props.onFinish({ data: result.data });
				})
				.catch((error) => {
					setLoading(false);
					props.onFinish({ error: error.message });
				});
		} else {
			setInputError(true);
		}
	};

	const onLocationChange = async (item: LocationObjProps) => {
		setInputError(false);
		setLocation(item);
	};

	return (
		<SectionContainer
			title={props.title ? props.title : "Tu dirección"}
			subtitle={
				props.subtitle
					? props.subtitle
					: "Solo necesitamos tu calle y el número para asignarte una residencia que esté cerca de ti."
			}
			buttonProps={{
				style: {
					backgroundColor: colors.buttonBackground,
					color: colors.buttonColor,
				},
				loading: loading,
				children: translation.component_button_next,
				onClick: onNextClick,
			}}
		>
			<InputLocation
				placeholder="Buscar dirección"
				containerStyle={{
					display: "flex",
					flex: 1,
					flexDirection: "column",
				}}
				design="secondary"
				isLoaded={isLoaded}
				error={inputError ? "Añade una dirección válida" : ""}
				LeftContent={
					<Search
						height={20}
						width={20}
						color={Color.text.high}
						style={{ marginRight: 8 }}
					/>
				}
				onLocationChange={onLocationChange}
			/>
		</SectionContainer>
	);
};
export default LocationStep;
export interface LocationProps {
	title?: string;
	subtitle?: string;
	user: UserScheme;
	onFinish: (result: { data?: UserScheme; error?: string }) => void;
}

interface LocationObjProps {
	address?: string;
	sortAddress?: string;
	route?: string;
	routeNumber?: string;
	routeInfo?: string;
	city?: string;
	province?: string;
	zipCode?: string;
	country?: string;
	location?: google.maps.LatLngLiteral;
	timeZone?: string;
}
